import { PrismicRichText } from "@prismicio/react";
import React from 'react';



export const FormstackForm = (props) => {

    const sc = props.slice.primary;

    let space = sc.spacing;

    if (space === "Both large") {
        space = "gutter";
    } else if (space === "Both small") {
        space = "gutter sm";
    } else if (space === "Top large") {
        space = "gutter bot";
    } else if (space === "Top small") {
        space = "gutter bot sm";
    } else if (space === "Bottom large") {
        space = "gutter top";
    } else {
        space = "gutter top sm";
    }

    let bg = sc.background === "gradient" ? "gradient-to-b from-grey-light to-white" : sc.background === "grey" ? "grey-light" : sc.background;

    const hasValidTitle = sc.form_title?.richText?.some(
        (block) => block.text?.trim() !== ""
    );

    return (
        <section id="inq" className={"bg-" + (bg) + " " + (sc.theme) + " " + (space)}>
            <div className="wrapper">
                
                <div className="bg-white p-12 w-full md:w-3/5 m-auto hs-center rounded-3xl shadow-2xl">
                {hasValidTitle && (
                    <div className={"text-2xl mb-4 text-" + sc.theme}>
                        <PrismicRichText field={sc.form_title.richText} />
                    </div>
                )}
                <PrismicRichText field={sc.form_content.richText} />
                <div dangerouslySetInnerHTML={{ __html: sc.html }} />
                <FormstackIframe formHeight={sc.form_height} formPath={sc.form_id} title={sc.form_title?.text || "Formstack Form"} />
                </div>
                
            </div>
        </section>
    );
}

function FormstackIframe({ formPath, formHeight, title = "Online Form" }) {
    

    return (
        <div className="relative">
            
            <iframe
                title={title}
                src={`https://quantum-health.formstack.com/forms/${encodeURIComponent(formPath)}?embedded=true`}
                width="100%"
                height={formHeight}
                frameBorder="0"
                scrolling="no"
                style={{ 
                    width: "100%", 
                    height: `${formHeight}px`,
                    minHeight: 400, 
                    border: "none", 
                    display: "block",
                    transition: "height 0.3s ease-in-out",
                }}
            />
        </div>
    );
}
